import { Button, Drawer, Grid, Icons, Input, Space, Typography, useDrawerForm } from '@pankod/refine-antd'
import { useTranslate } from '@pankod/refine-core'
import { definitions } from 'interfaces'
import { useState } from 'react'
import { Trans } from 'react-i18next'
import { CURRENT_DATE_TIME, PURCHASE_BY_MARKET_ORDER_ID_REVIEWED_TEMPLATE_PATH, PURCHASE_REVIEWED_TEMPLATE_PATH, supabaseClient } from 'utility'
import { read, utils } from 'xlsx'

type ReviewedPurchaseButtonProps = {
  filename: string
}

type ReviewedPurchaseRow = { orderId: Number, invoiceNumber?: string, marketOrderId?: Number }

export const ReviewedPurchaseButton = ({ filename }: ReviewedPurchaseButtonProps) => {
  const t = useTranslate()
  const breakpoint = Grid.useBreakpoint()
  filename = `${filename} ${CURRENT_DATE_TIME}.xlsx`

  const {
    drawerProps: editDrawerProps,
    show: editShow
  } = useDrawerForm<definitions['market_orders']>({
    action: 'edit',
    redirect: false
  })

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  const [updateFile, setUpdateFile] = useState(null)
  const [updateFileById, setUpdateFileById] = useState(null)
  const [updateFinished, setUpdateFinished] = useState<string | null>(null)

  // const [updated, setUpdated] = useState<{ orderId: Number, invoiceNumber: string }[]>([])
  const [failed, setFailed] = useState<ReviewedPurchaseRow[]>([])

  const handleFile = (e: any) => {
    setUpdateFile(e.target.files[0])
  }

  const handleFileByMarketId = (e: any) => {
    setUpdateFileById(e.target.files[0])
  }

  const updatePurchaseToReviewed = async (orderId: Number, invoiceNumber: String) => {
    // console.log(orderId, invoiceNumber)
    const { error } = await supabaseClient.from('market_orders')
      .update({ reviewed: true, updated_by: supabaseClient.auth.user()?.email })
      .eq('order_id', orderId)
      .eq('invoice_number', invoiceNumber)

    if (error) return false
    return true
  }

  const updatePurchaseToReviewedByMarketOrderId = async (orderId: Number, marketOrderId: Number) => {
    const { error } = await supabaseClient.from('market_orders')
      .update({ reviewed: true, updated_by: supabaseClient.auth.user()?.email })
      .eq('order_id', orderId)
      .eq('id', marketOrderId)

    if (error) return false
    return true
  }

  const readUploadedFile = async (e: any, isByMarketId = false) => {
    e.preventDefault()
    setLoading(true)
    setUpdateFinished(null)

    // const updatedMO: { orderId: Number, invoiceNumber: string }[] = []
    const failedMO: ReviewedPurchaseRow[] = []

    const reader = new FileReader()
    reader.onload = async function (e) {
      try {
        const data = e?.target?.result
        const readedData = read(data, { type: 'binary' })
        const wsname = readedData.SheetNames[0]
        const ws = readedData.Sheets[wsname]

        const dataParse: any = utils.sheet_to_json(ws, { header: 1 })

        let index = 0

        for (const m of dataParse) {
          if (index > 0) {
            console.log(typeof m[0], typeof m[1])
            if (typeof m[1] === 'number') {
              const row = isByMarketId ? { orderId: Number(m[1]), marketOrderId: Number(m[0]) } : { orderId: Number(m[1]), invoiceNumber: String(m[0]) }
              const res = isByMarketId ? await updatePurchaseToReviewedByMarketOrderId(row.orderId, row.marketOrderId!) : await updatePurchaseToReviewed(row.orderId, row.invoiceNumber!)

              if (!res) failedMO.push(row)
              // else updatedMO.push(row)
            } else {
              isByMarketId ? failedMO.push({ orderId: Number(m[1]), marketOrderId: Number(m[0]) }) : failedMO.push({ orderId: Number(m[1]), invoiceNumber: String(m[0]) })
            }
          }
          index += 1
        }

        setLoading(false)
        setUpdateFile(null)
        setUpdateFileById(null)
        setFailed(failedMO)
        // setUpdated(updatedMO)
        setUpdateFinished('ok')
      } catch (err) {
        setError(true)
        setLoading(false)
        setUpdateFile(null)
        setUpdateFileById(null)
        setFailed(failedMO)
        // setUpdated(updatedMO)
        setUpdateFinished('error')
      }
    }

    if (updateFile && !isByMarketId) {
      reader.readAsBinaryString(updateFile)
    }

    if (updateFileById && isByMarketId) {
      reader.readAsBinaryString(updateFileById)
    }
  }

  return <>
    <Button type="primary" onClick={() => editShow()}>
      {t('market_order.reviewedPurchase.title')}
    </Button>
    <Drawer
      {...editDrawerProps}
      width={breakpoint.sm ? '800px' : '100%'}
      bodyStyle={{ padding: 0 }}
      zIndex={1001}
    >
      <Space style={{ width: '100%', display: 'grid', marginTop: '5%', marginBottom: '5%', marginLeft: '10%' }} direction="vertical" size={12}>
        <Typography.Text>
          {t('market_order.reviewedPurchase.title')}
        </Typography.Text>

        <a href={PURCHASE_REVIEWED_TEMPLATE_PATH} download="purchases-reviewed-template.xlsx">
          <Button>
            <Icons.DownloadOutlined />
            {t('market_order.reviewedPurchase.labelTemplate')}
          </Button>
        </a>

        <Typography.Text>
          <b>{t('market_order.reviewedPurchase.advise')}</b>
        </Typography.Text>

        <Typography.Text>{t('marketplace.actions.uploadExcel')}</Typography.Text>
        <Input
          accept='.xlsx'
          bordered={false}
          size='middle'
          type='file'
          key='exceluploader'
          onChange={handleFile}
        />
        <Button disabled={updateFile === null} loading={loading} type='primary'
          onClick={(e: any) => readUploadedFile(e)}
        >
          {t('market_order.reviewedPurchase.labelUpdate')}
        </Button>

        {loading && <Typography style={{ marginTop: '2rem', fontWeight: 600, fontStyle: 'italic' }}>
          {t('market_order.reviewedPurchase.labelUpdating')}
        </Typography>}
        {updateFinished && <Typography style={{ marginTop: '2rem', fontWeight: 600, fontStyle: 'italic' }}>
          {t(`market_order.reviewedPurchase.labelFinish${updateFinished}`)}
        </Typography>}

      </Space>

      <hr />

      <Space style={{ width: '100%', display: 'grid', marginTop: '5%', marginLeft: '10%' }} direction="vertical" size={12}>
        <Typography.Text>
          <Trans
            i18nKey="market_order.reviewedPurchase.internIDTitle"
            components={{ b: <b /> }}
          />
        </Typography.Text>

        <a href={PURCHASE_BY_MARKET_ORDER_ID_REVIEWED_TEMPLATE_PATH} download="purchases-by-market_order-id-reviewed-template.xlsx">
          <Button>
            <Icons.DownloadOutlined />
            {t('market_order.reviewedPurchase.labelTemplate')}
          </Button>
        </a>

        <Typography.Text>
          <b>{t('market_order.reviewedPurchase.advise')}</b>
        </Typography.Text>

        <Typography.Text>{t('marketplace.actions.uploadExcel')}</Typography.Text>
        <Input
          accept='.xlsx'
          bordered={false}
          size='middle'
          type='file'
          key='exceluploader'
          onChange={handleFileByMarketId}
        />
        <Button disabled={updateFileById === null} loading={loading} type='primary'
          onClick={(e: any) => readUploadedFile(e, true)}
        >
          {t('market_order.reviewedPurchase.labelUpdate')}
        </Button>

        {loading && <Typography style={{ marginTop: '2rem', fontWeight: 600, fontStyle: 'italic' }}>
          {t('market_order.reviewedPurchase.labelUpdating')}
        </Typography>}
        {updateFinished && <Typography style={{ marginTop: '2rem', fontWeight: 600, fontStyle: 'italic' }}>
          {`${t(`market_order.reviewedPurchase.labelFinish${updateFinished}`)} (${t('market_order.reviewedPurchase.reloadWindow')})`}
        </Typography>}
      </Space>

      {(error)
        ? <Space style={{ width: '100%', display: 'grid', marginTop: '5%', marginLeft: '10%' }} direction="vertical" size={12}>
          <Typography.Text>{t('market_order.reviewedPurchase.error')}</Typography.Text>
        </Space>
        : (failed.length > 0) && <Space>
          <Typography.Text>{t('market_order.reviewedPurchase.marketOrderFailed')}</Typography.Text>
          {failed.map((fmo: ReviewedPurchaseRow, index: number) => <p key={index}>{Number(fmo.orderId)} -- {fmo.invoiceNumber}</p>)}
        </Space>}
    </Drawer>
  </>
}
